module.exports = __webpack_public_path__ + "img/cfe_mockup.3be0d962.png";